import styled from 'styled-components';
import { ModalBody } from 'reactstrap';

const StyledModalBody = styled(ModalBody)`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #6e7582;
`;

const StyledTips = styled.div`
  h3 {
    margin: 16px 0;
    color: #33373d;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
  }
  a {
    text-decoration: underline;
    display: inline-block;
  }
`;

export { StyledModalBody, StyledTips };
